import { useForm } from 'react-hook-form';
import zod from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useFetch } from '../../hooks';
import { login } from '../../config';
import { useNavigate } from 'react-router-dom';

const Message = {
  minPassword: 'Le mot de passe doit contenir au moins huit (8) caractères.',
  required: 'Ce champ est requis.',
  invalidEmail: 'Adresse email non valide.',
};

const schema = zod.object({
  password: zod.string().nonempty({ message: Message.required }).min(8, { message: Message.minPassword }),
  email: zod.string().nonempty({ message: Message.required }).email(Message.invalidEmail),
});

export const useLoginForm = () => {
  const form = useForm({ mode: 'all', resolver: zodResolver(schema) });
  const { fetch, ...others } = useFetch(login);
  const navigate = useNavigate();

  const handleSubmit = e => {
    e.preventDefault();
    fetch(form.watch())
      .then(() => navigate(others.value))
      .catch(console.log);
  };

  return { form, handleSubmit, ...others };
};
